import { useMemo } from 'react';
import { useDateQueryParams } from '../../../../hooks';
export var useFindShiftsPageInitialQueryParams = function () {
    var selectedDate = useDateQueryParams().selectedDate;
    var initialSelectedDate = useMemo(function () { return selectedDate; }, []);
    // Start time to begin at start of selected day
    var startTime = useMemo(function () { return initialSelectedDate.startOf('day').toUTC().toISO(); }, [initialSelectedDate]);
    // Only fetch data for current day initially
    var endTime = useMemo(function () { return initialSelectedDate.endOf('day').toUTC().toISO(); }, [initialSelectedDate]);
    return {
        selectedDate: initialSelectedDate,
        startTime: startTime,
        endTime: endTime
    };
};
